export default __webpack_public_path__ + "static/media/idle3.a8dbfd17.mp3";